import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { AnswerJourneyView } from './answer-journey.mapper';

/**
 * "Answer journey" card for one question: time/visit/change stats, a timeline of
 * visits and answer actions from tracked exam events, and a one-line takeaway.
 * Build the input with `buildAnswerJourney()`.
 */
@Component({
  selector: 'app-answer-journey',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './answer-journey.html',
  styleUrl: './answer-journey.css',
})
export class AnswerJourneyComponent {
  readonly journey = input.required<AnswerJourneyView>();
}
